import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6 3.25a.75.75 0 0 0-.75.75v16c0 .414.336.75.75.75h9a4.75 4.75 0 0 0 1.993-9.062q.191-.155.366-.33A4.75 4.75 0 0 0 14 3.25zm8 8a3.25 3.25 0 1 0 0-6.5H6.75v6.5zm-7.25 1.5v6.5H15a3.25 3.25 0 1 0 0-6.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }